import { action, observable, makeObservable } from 'mobx';
import { SignUpMainSteps } from './stepsStructure/SignupMainSteps';
import { SignUpParamsType } from './SignUpParams';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AccountState } from 'src/domains/players/shared/Types';

export class SignUpState {
    @observable public isLoading: boolean = false;

    public currentView: SignUpMainSteps;

    public constructor(public readonly params: SignUpParamsType) {
        makeObservable(this);
        this.currentView = new SignUpMainSteps(params, this.setLoading);
    }

    @action public rebuildState = (): void => {
        const googleTagManager = GoogleTagManagerState.get(this.params.common);
        this.currentView = new SignUpMainSteps(this.params, this.setLoading);
        googleTagManager.renderNewUuid();
    };

    @action public setLoading = (isLoading: boolean): void => {
        this.isLoading = isLoading;
    };

    @action public toggleAside = async (): Promise<void> => {
        StarRouter.get(this.params.common).closeAccount();
        const accountState = AccountState.get(this.params.common);
        await this.params.modalState.closeAll();

        if (this.isLoading) {
            await accountState.handleLogout();
        }
    };
}
